import {hideElem, showElem} from '../utils/dom.ts';
import {isDarkTheme} from '../utils.ts';

export function initUserSettings() {
  if (!document.querySelector('.user.settings.profile')) return;

  const usernameInput = document.querySelector<HTMLInputElement>('#username');
  if (!usernameInput) return;
  usernameInput.addEventListener('input', function () {
    const prompt = document.querySelector('#name-change-prompt')!;
    const promptRedirect = document.querySelector('#name-change-redirect-prompt')!;
    if (this.value.toLowerCase() !== this.getAttribute('data-name')!.toLowerCase()) {
      showElem(prompt);
      showElem(promptRedirect);
    } else {
      hideElem(prompt);
      hideElem(promptRedirect);
    }
  });
}

let latestThemeLink: HTMLLinkElement | null = null;

function previewTheme(name: string, href: string) {
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = href;
  latestThemeLink = link;
  // apply the new stylesheet before removing the old one to avoid a flash of unstyled page
  link.addEventListener('load', () => {
    if (link !== latestThemeLink) { // a newer theme was picked meanwhile
      link.remove();
      return;
    }
    document.querySelector('#theme-stylesheet')?.remove();
    link.id = 'theme-stylesheet';
    document.documentElement.setAttribute('data-theme', name);
    document.documentElement.setAttribute('data-gitea-theme-dark', String(isDarkTheme()));
  });
  link.addEventListener('error', () => link.remove());
  document.head.append(link);
}

export function initUserSettingsThemePreview() {
  const input = document.querySelector<HTMLInputElement>('.user.settings.appearance input[name=theme]');
  if (!input) return;
  input.addEventListener('change', () => {
    const item = input.closest('.dropdown')!.querySelector(`.item[data-value="${CSS.escape(input.value)}"]`);
    if (item) previewTheme(input.value, item.getAttribute('data-href')!);
  });
}
